import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { scrollToFragment } from '../utils/scroll-to-fragment';

@Component({
  selector: 'app-contact-redirect',
  standalone: true,
  template: '',
})
export class ContactRedirectComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/'], { fragment: 'contact', replaceUrl: true }).then(() => {
      scrollToFragment('contact');
    });
  }
}
